<template>
  <v-progress-linear indeterminate />
</template>
